import { render, staticRenderFns } from "./CounterBar.vue?vue&type=template&id=523f680e&"
import script from "./CounterBar.vue?vue&type=script&lang=js&"
export * from "./CounterBar.vue?vue&type=script&lang=js&"
import style0 from "./CounterBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports